import React, { useState, useEffect, useContext, useRef } from "react";
import { Button } from "react-bootstrap";
import { get, isEmpty, sortBy, groupBy, isUndefined } from "lodash";
import "../../../styles/containers/CommunicationContainer.scss";
import { Formik } from "formik";
import {
  ManageCommunicationLayout,
  PlanlevelCommunication,
  LoaderWrapper,
  PillComponent,
} from "../../../components";
import {
  channelForCommunication,
  MANAGE_COMMUNICATION_ROUTES,
  getAdvancedPathWithParam,
} from "../../../utils";
import { useRouterParams, useDeepEffect } from "../../../abstracts";
import {
  getConfiguredCommunicationsBasedOnEvent,
  getCommunicationsBasedOnSelectedPlan,
} from "../../../services";
import AddToolTip from "../../../components/AddToolTip";
import { manageCommunicationStore } from "../../../contexts";
import {
  faPencilAlt,
  faTimes,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
const initialValues = {};
const ConfigureCommunicationContainer = (props) => {
  const customBreadCrumbs = [
    {
      label: "Plan Communication",
      link: MANAGE_COMMUNICATION_ROUTES.CONFIGURE_COMMUNICATION,
    },
  ];
  const { history } = props;
  const [index, setIndex] = useState(0);
  const { eventOrScheduleName, eventId, planId } = useRouterParams();
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterdata, setFilterData] = useState(data1);
  const channel = useRef("");
  const [activeMail, setActiveMail] = useState("");
  const [activeSMS, setActiveSMS] = useState("");
  const apiResponse = useRef("");
  const communicationMode = useRef(0);
  const [statusChangeToggle, setStatusChangeToggle] = useState(false);
  const Level = [0, "Global", "PlanLevel", "PlanGroupLevel"];
  const buttons = [
    {
      //label: "cancel",
      variant: "link",
      type: "button",
      icon: faTimes,
      style: { marginRight: "30px" },
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: `${MANAGE_COMMUNICATION_ROUTES.PLAN_LEVEL_COMMUNICATION}`,
            //pathParam: [flow, censusId],
          })
        ),
    },
  ];
  useEffect(() => {
    if (!isUndefined(eventOrScheduleName)) {
      setLoading(true);
      getConfiguredCommunicationsBasedOnEvent({
        eventId: parseInt(eventId, 10),
        planId: parseInt(planId, 10),
      })
        .then((response) => {
          setLoading(false);
          apiResponse.current = response;
          response.forEach((x) => {
            if (x.modeOfCommunication === 1 && x.isActive)
              setActiveMail(x.communicationDetail?.name + "/" + Level[x.level]);
            else if (x.modeOfCommunication === 2 && x.isActive)
              setActiveSMS(x.communicationDetail?.name + "/" + Level[x.level]);
          });
          setData1(groupBy(response, "level"));
          setFilterData(groupBy(response, "level"));
        })
        .catch(() => {
          setLoading(false);
        });
    }
    channel.current = Object.keys(channelForCommunication).find(
      (x) => channelForCommunication[x] == 1
    );
    // getCommunicationsBasedOnSelectedPlan({
    //   search: "",
    //   planId: parseInt(planId, 10),
    // }).then((response) => {
    //   const x = response[configureCommunicationindex];
    //   channel.current = x.channel;
    //   setActiveMail(
    //     x.configuredCommunications.find((_) => _.channelOfCommunication === 1)
    //       ?.communicationNameWithActiveLevel
    //   );
    //   setActiveSMS(
    //     x.configuredCommunications.find((_) => _.channelOfCommunication === 2)
    //       ?.communicationNameWithActiveLevel
    //   );
    // });
  }, [eventOrScheduleName]);

  const cardDataAll = (val) => {
    communicationMode.current = val;
    if (val == 1) {
      var carddata = groupBy(
        apiResponse.current.filter((x) => x.modeOfCommunication == "1"),
        "level"
      );
      setFilterData(carddata);
    } else if (val == 2) {
      var carddata = groupBy(
        apiResponse.current.filter((x) => x.modeOfCommunication == "2"),
        "level"
      );
      setFilterData(carddata);
    } else setFilterData(data1);
  };
  useDeepEffect(() => {
    cardDataAll(communicationMode.current);
  }, [statusChangeToggle]);

  const handleClick = (input, data) => {
    cardDataAll(input);
    setIndex(input);
  };

  const options = [
    {
      label: "All",
      index: 0,
    },
    {
      label: "E-Mail",
      index: 1,
    },
    // {
    //   label: "SMS",
    //   index: 2,
    // },
  ];

  const planLevelComm = (y) => {
    return (
      <PlanlevelCommunication
        //isPlanLevel
        data={y}
        setActiveMail={setActiveMail}
        setActiveSMS={setActiveSMS}
        setFilterData={setFilterData}
        eventId={eventId}
        planId={planId}
        CommunicationMode={communicationMode.current}
        setStatusChangeToggle={setStatusChangeToggle}
        statusChangeToggle={statusChangeToggle}
        apiResponse={apiResponse}
        setData1={setData1}
        communicationMode={Level}
        history={history}
      />
    );
  };
  return (
    <LoaderWrapper isLoading={loading}>
      <ManageCommunicationLayout
        pageName="Configure Communication"
        customBreadCrumbs={customBreadCrumbs}
        buttons={buttons}
        overflow={"hidden"}
      >
        <div>
          <div className="d-fl">
            <div>
              <p className="gr w-224 ft-14">Event</p>
              <p className="w-224 ftwt-500">
                {eventOrScheduleName?.length > 25 ? (
                  <AddToolTip name={eventOrScheduleName} />
                ) : (
                  eventOrScheduleName
                )}
              </p>
            </div>
            <div>
              <p className="gr ml-100 ft-14">Configured Communication - Mail</p>
              <p className="ml-100 ftwt-500 ft-14">
                {isEmpty(activeMail) ? (
                  "None"
                ) : (
                  <>
                    <i
                      class="fa fa-envelope"
                      aria-hidden="true"
                      style={{ marginRight: "10px", color: "#777777" }}
                    ></i>
                    {activeMail}
                  </>
                )}
              </p>
            </div>
          </div>
          <div className="d-fl mt-25">
            <div>
              <p className="gr w-224 ft-14">Channel</p>
              <p className="w-224 ftwt-500 ft-14">{channel.current}</p>
            </div>
            {/* <div>
              <p className="gr ml-100 ft-14">Configured Communication - SMS</p>
              <p className="ml-100 ftwt-500 ft-14">
                {isEmpty(activeSMS) ? (
                  "None"
                ) : (
                  <>
                    <i
                      class="fas fa-sms"
                      style={{ marginRight: "10px", color: "#777777" }}
                    ></i>

                    {activeSMS}
                  </>
                )}
              </p>
            </div> */}
          </div>
        </div>
        <hr className="ft-clr"></hr>
        {/* <div className="pillInputButton mt-3 d-flex mb-10p"> */}
        {/* {options?.map((_) => {
            return (
              <PillComponent
                label={_?.label}
                handleClick={handleClick}
                inputForClick={_?.index}
                className={
                  _?.index == index ? "filteredActiveButton mr-10p" : "mr-10p"
                }
                isInput={false}
              />
            );
          })} */}
        {/* </div> */}
        <div style={{ height: "85%" }}>
          {!isEmpty(filterdata) > 0 ? (
            Object.keys(filterdata).map((x) => {
              const label =
                x === "2"
                  ? "Plan Level"
                  : x === "3"
                  ? "Plan Group Level"
                  : "Global";
              return (
                <>
                  <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                    <div className="ft-14 mb-25">{label}</div>
                    {filterdata[x].map((y) => {
                      return planLevelComm(y);
                    })}

                    <hr
                      className="plancard-border"
                      style={{ width: "120%" }}
                    ></hr>
                  </div>
                </>
              );
            })
          ) : (
            <span
              style={{
                margin: "auto",
                textAlign: "center",
                fontSize: "18px",
                color: "#333333",
              }}
            >
              No Records Found
            </span>
          )}
        </div>
      </ManageCommunicationLayout>
    </LoaderWrapper>
  );
};

export default ConfigureCommunicationContainer;
